import script from "./OrganizationDiagram.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationDiagram.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./OrganizationDiagram.vue?vue&type=style&index=1&id=85a3e54a&scoped=true&lang=css"
import "./OrganizationDiagram.vue?vue&type=style&index=2&id=85a3e54a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85a3e54a"]])

export default __exports__